import script from "./addPotentialForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./addPotentialForm.vue?vue&type=script&setup=true&lang=ts"

import "./addPotentialForm.vue?vue&type=style&index=0&id=392a93bf&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392a93bf"]])

export default __exports__